import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireAuth } from './components/RequireAuth'
import { RequirePermissao } from './components/RequirePermissao'
import { AppLayout } from './layout/AppLayout'
import { ConversoesPage } from './pages/ConversoesPage'
import { LoginPage } from './pages/LoginPage'
import { MarcasPage } from './pages/MarcasPage'
import { IaPage } from './pages/IaPage'
import { LeadsPage } from './pages/LeadsPage'
import { PapeisPage } from './pages/PapeisPage'
import { UsuariosPage } from './pages/UsuariosPage'
import { OrganicoPage } from './pages/OrganicoPage'
import { RedesSociaisPage } from './pages/RedesSociaisPage'
import { ResumosPage } from './pages/ResumosPage'
import { RelatorioImpressaoPage } from './pages/RelatorioImpressaoPage'
import { ChatPage } from './pages/ChatPage'
import { AlertasPage } from './pages/AlertasPage'
import { AlteracoesPage } from './pages/AlteracoesPage'
import { SimuladorPage } from './pages/SimuladorPage'
import { TrafegoPagoPage } from './pages/TrafegoPagoPage'
import { FiltrosProvider } from './state/FiltrosContext'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        {/* Fora do layout: a página de impressão não tem menu. */}
        <Route path="/relatorio/:id" element={<RelatorioImpressaoPage />} />
        <Route
          element={
            <FiltrosProvider>
              <AppLayout />
            </FiltrosProvider>
          }
        >
          <Route index element={<Navigate to="/trafego-pago" replace />} />
          <Route path="/trafego-pago" element={<TrafegoPagoPage />} />
          <Route path="/organico" element={<OrganicoPage />} />
          <Route path="/redes-sociais" element={<RedesSociaisPage />} />
          <Route path="/resumos" element={<ResumosPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/alertas" element={<AlertasPage />} />
          <Route path="/alteracoes" element={<AlteracoesPage />} />
          <Route path="/simulador" element={<SimuladorPage />} />
          <Route element={<RequirePermissao permissao="leads.ver" />}>
            <Route path="/leads" element={<LeadsPage />} />
          </Route>
          <Route element={<RequirePermissao permissao={['marcas.gerenciar', 'marcas.conectar']} />}>
            <Route path="/configuracoes/marcas" element={<MarcasPage />} />
          </Route>
          <Route element={<RequirePermissao permissao="conversoes.gerenciar" />}>
            <Route path="/configuracoes/conversoes" element={<ConversoesPage />} />
          </Route>
          <Route element={<RequirePermissao permissao="usuarios.gerenciar" />}>
            <Route path="/configuracoes/usuarios" element={<UsuariosPage />} />
          </Route>
          <Route element={<RequirePermissao permissao="papeis.gerenciar" />}>
            <Route path="/configuracoes/papeis" element={<PapeisPage />} />
          </Route>
          <Route element={<RequirePermissao permissao="ia.gerenciar" />}>
            <Route path="/configuracoes/ia" element={<IaPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
